import React from 'react';
import { render_integration_fields } from '../integrationCatalog';

const IntegrationConfig = ({
    integration_key,
    places,
    tickettypes,
}) => (
    <div className="IntegrationConfig">
        <div className="IntegrationConfig-fields">
            {render_integration_fields(integration_key, { places, tickettypes })}
        </div>
    </div>
);

export default IntegrationConfig;
